export enum PgnShapeRenderMode {
    ADD = "+",
    SUBTRACT = "-"
}
